import {
  Button,
  Container,
  FormLabel,
  Grid,
  Paper,
  Stack,
} from "@mui/material";
import InputSelect from "../../components/FormElements/InputSelect";
import { TRP_TYPE } from "../../constants/transparencia";
import { useCallback, useEffect, useState } from "react";
import {
  SEA_PROGRAMA_EDUCATIVO,
  SEA_REGION,
  SEA_TRIMESTRE,
} from "../../constants/sea";
import moment from "moment";
import { capitalizeString } from "../../utils/utils";
import InputDatePicker from "../../components/FormElements/InputDatePicker";

const initialState = {
  trp_type: "",
  trp_pe: "",
  trp_reg: "",
  trp_trimestre: "",
  trp_month: "",
  trp_from: "",
  trp_until: "",
};

const Transparencia = () => {
  const [filter, setFilters] = useState(initialState);
  const handleChange = useCallback((e) => {
    console.log(e);
  }, []);
  const handleReset = useCallback((e) => {
    setFilters(initialState);
  }, []);
  const handleSearch = useCallback(
    (e) => {
      console.log(filter);
    },
    [filter]
  );

  useEffect(() => {
    console.log(
      moment.monthsShort().map((val, i) => ({
        _id: i + 1,
        value: moment().month(i).format("MMMM"),
      }))
    );
  }, []);

  return (
    <Container component="main" maxWidth="xl" sx={{ mb: 4 }}>
      <Paper
        variant="outlined"
        sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
      >
        <Grid container spacing={2}>
          <Grid item xs="12" md="4">
            <InputSelect
              id={"trp_type"}
              label="Tipo"
              opts={TRP_TYPE}
              placeholder=""
              initialValue={filter?.trp_type}
              onChangeInput={handleChange}
            />
          </Grid>
          <Grid item xs="12" md="4">
            <InputSelect
              id={"trp_pe"}
              label="Programa Educativo"
              opts={SEA_PROGRAMA_EDUCATIVO}
              placeholder=""
              initialValue={filter?.trp_pe}
              onChangeInput={handleChange}
            />
          </Grid>
          <Grid item xs="12" md="4">
            <InputSelect
              id={"trp_pe"}
              label="Région"
              opts={SEA_REGION}
              placeholder=""
              initialValue={filter?.trp_reg}
              onChangeInput={handleChange}
            />
          </Grid>
          <Grid item xs="12" md="4">
            <InputSelect
              id={"trp_trimestre"}
              label="Trimestre"
              opts={SEA_TRIMESTRE}
              placeholder=""
              initialValue={filter?.trp_trimestre}
              onChangeInput={handleChange}
            />
          </Grid>
          {/* <Grid item xs="12" md="4">
            <InputSelect
              id={"trp_mes"}
              label="Mes"
              opts={moment.monthsShort().map((val, i) => ({
                _id: i + 1,
                label: capitalizeString(moment().month(i).format("MMMM")),
              }))}
              placeholder=""
              initialValue={filter?.trp_mes}
              onChangeInput={handleChange}
            />
          </Grid> */}
          <Grid item xs="12" md="4">
            <InputDatePicker
              id={"trp_from"}
              label="Desde"
              onChange={(value) => {
                console.log(value);
              }}
              initialValue={filter?.trp_from}
              error={""}
              isDisabled={false}
            />
          </Grid>
          <Grid item xs="12" md="4">
            <InputDatePicker
              id={"trp_until"}
              label="Hasta"
              onChange={(value) => {
                console.log(value);
              }}
              initialValue={filter?.trp_until}
              error={""}
              isDisabled={false}
            />
          </Grid>
          <Grid item xs="12">
            <Stack
              spacing={2}
              direction="row"
              alignItems={"center"}
              justifyContent={"center"}
              sx={{ my: 4 }}
            >
              <Button
                variant="contained"
                onClick={handleSearch}
                autoFocus
                sx={{ padding: "5px 40px", fontWeight: "700" }}
              >
                Buscar Actas
              </Button>
              <Button
                variant="outlined"
                sx={{
                  marginRight: "auto",
                  padding: "5px 40px ",
                  fontWeight: "700",
                }}
                onClick={handleReset}
              >
                Limpiar Filtros
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};
export default Transparencia;
